import config from './config'
import { handleResponse } from './handle-response'
import { checkToken, authHeader } from './helpers'

export const plansService = {
    list,
    listByReportNumber,
	listTransactions,
	listWallet
}

async function list() {

    await checkToken()

    const requestOptions = { method: 'GET', headers: authHeader()}
    return fetch(`${config.apiUrl}/plan/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function listByReportNumber() {

    await checkToken()

    const requestOptions = { method: 'GET', headers: authHeader()}
    return fetch(`${config.apiUrl}/plans-by-reports/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function listTransactions(urlParams = '') {
	await checkToken();
	
	const requestOptions = { method: 'GET', headers: authHeader() };
	return fetch(`${config.apiUrl}/transaction/${urlParams}`, requestOptions)
	  .then(handleResponse)
	  .then(data => {
		return data;
	  });
  }

  async function listWallet(urlParams = '') {
	await checkToken();
	
	const requestOptions = { method: 'GET', headers: authHeader() };
	return fetch(`${config.apiUrl}/wallet/${urlParams}`, requestOptions)
	  .then(handleResponse)
	  .then(data => {
		return data;
	  });
}